import React from 'react';
import { Link } from 'react-router-dom';
import './OurStory.css';

const OurStory = () => {
  return (
    <section className="ourstory-section">
      <div className="ourstory-container">
        <div className="ourstory-row">
          {/* Left Content */}
          <div className="ourstory-content-col">
            <div className="ourstory-inner">
              <h4 className="ourstory-subtitle">Our Story</h4>
              <h1 className="ourstory-title">Our Journey is Built on Trust.</h1>

              <p className="ourstory-description">
                Founded by certified electricians with a passion for precision, Musa Electrical began with one goal: 
                to make reliable electrical services accessible, honest, and fast. What started as a small operation 
                has grown into a full-scale service team trusted by hundreds of homeowners and businesses across the region.
              </p>

              {/* Mission & Vision Cards */}
              <div className="ourstory-mv-cards">
                <div className="mv-card">
                  <span className="mv-icon">🎯</span>
                  <h3>Our Mission</h3>
                  <p>To deliver safe, reliable, and innovative electrical solutions that empower homes and businesses, 
                    while maintaining the highest standards of quality and customer satisfaction.</p>
                </div>
                <div className="mv-card">
                  <span className="mv-icon">🔭</span>
                  <h3>Our Vision</h3>
                  <p>To become the most trusted electrical services provider in Kenya, setting the benchmark 
                    for excellence, sustainability, and community impact in every project we undertake.</p>
                </div>
              </div>

              {/* Goals */}
              <div className="ourstory-goals">
                <h3 className="goals-title">Our Goals</h3>
                <div className="goals-list">
                  <div className="goal-item">
                    <span className="goal-icon">✓</span>
                    <p>Expand our renewable energy solutions to reach 500+ homes annually</p>
                  </div>
                  <div className="goal-item">
                    <span className="goal-icon">✓</span>
                    <p>Maintain a 98% customer satisfaction rate through quality service delivery</p>
                  </div>
                  <div className="goal-item">
                    <span className="goal-icon">✓</span>
                    <p>Train and certify 50+ new electricians to address the growing demand</p>
                  </div>
                  <div className="goal-item">
                    <span className="goal-icon">✓</span>
                    <p>Implement smart home technology solutions for modern living standards</p>
                  </div>
                </div>
              </div>

              <Link to="/contact" className="ourstory-btn">Contact Us</Link>
            </div>
          </div>

          {/* Right Images */}
          <div className="ourstory-images-col">
            <div className="ourstory-images-wrapper">
              <img 
                src={process.env.PUBLIC_URL + "/images/about/about-main.jpg"} 
                alt="Electrical Work" 
                className="ourstory-main-image"
              />
              <div className="ourstory-experience-badge">
                <div className="badge-inner">
                  <h2>10+</h2>
                  <p>Years of Experience</p>
                </div>
              </div>
              <div className="ourstory-secondary-image-wrap">
                <img 
                  src={process.env.PUBLIC_URL + "/images/about/about-secondary.jpg"} 
                  alt="Musa Electrical Team" 
                  className="ourstory-secondary-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
